import { jsxs as l, jsx as r } from "react/jsx-runtime";
import { isOrHandleAsExternalUrl as i } from "../../../helpers/link-helper.js";
import "dayjs";
import { OutlineButtonLink as n } from "../button/button.js";
import a from "./section-info.module.less.js";
const N = ({ heading: o, text: s, textNode: t, link: e }) => /* @__PURE__ */ l("div", { className: a.wrapper, children: [
  o && /* @__PURE__ */ r("p", { className: ["h5", a.heading].join(" "), children: o }),
  s && /* @__PURE__ */ r("div", { className: "body-base", dangerouslySetInnerHTML: { __html: s || "" } }),
  t && /* @__PURE__ */ r("div", { className: "body-base", children: t }),
  /* @__PURE__ */ r("div", { className: [a.content].join(" ") }),
  e && /* @__PURE__ */ r("div", { className: a.buttonWrapper, children: /* @__PURE__ */ r(
    n,
    {
      url: e?.url,
      label: e?.title,
      isFullWidth: !0,
      openInNewTab: i(e?.url, e?.target),
      onPreNavigate: e.onPreNavigate
    }
  ) })
] });
export {
  N as SectionInfo,
  N as default
};
